/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow_circle': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M8.778 5.19A13 13 0 0116 3a13.015 13.015 0 0113 13A13 13 0 118.778 5.19zm11.847 10.976a.998.998 0 00.541-1.306.998.998 0 00-.217-.325l-4.24-4.24a1.003 1.003 0 00-1.417 0l-4.241 4.24a1 1 0 001.414 1.414L15 13.414V21a1 1 0 002 0v-7.586l2.535 2.535a.998.998 0 001.09.217z" _fill="#0B2C62"/>'
  }
})
